import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Hidden from "@material-ui/core/Hidden";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import { withRouter, useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import { isHamburguerMenu } from "../../../utils/objectManipulations";
import BreadcrumbsComponent from "./BreadcrumbsComponent";
import useStyles from "./styles";
import Logo from "../../../assets/images/logo-cargill.png";
import Confirm from "../../Confirm";

function MainAppBar({
  notifications,
  user,
  user: { groups },
  handleDrawerToggle,
  window,
  location,
  clearNewUser,
  selectedUser,
  menus,
  clearSelectedUser,
  managerId,
  setManager,
  isAutoImportEnabled,
  updateAutoImportEnabled,
  getNotificationsFromSchedConfigAsync,
  ...props
}) {
  const classes = useStyles();
  const theme = useTheme();
  const anchor = theme.direction === "rtl" ? "left" : "right";
  const pathnames = location.pathname.split("/").filter((x) => x);
  const history = useHistory();
  const [activeRoute, setActiveRoute] = useState("");
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [isToggledDrawer, setToggleDrawer] = useState({
    left: false,
    right: false,
  });
  const [isAutoImported, setAutoImported] = useState(false);
  const canToggleAutoImport = useCallback(
    () => user.groups.includes("support"),
    [user.groups]
  );
  const canManageUser = () => user.groups.includes("user_admin");
  const manageUserRoute = () =>
    location.pathname.includes(`/gerenciar-usuarios/listar-usuarios`);
  const [showConfirmToggleImportOC, setShowConfirmToggleImportOC] =
    useState(false);

  const newUser = "/gerenciar-usuarios/novo-usuario";
  const approveUser = "/gerenciar-usuarios/aprovar-usuarios";

  const toggleDrawer = useCallback(
    (anchor, open) => (event) => {
      if (
        event &&
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      setToggleDrawer({ ...isToggledDrawer, [anchor]: open });
    },
    [isToggledDrawer, setToggleDrawer]
  );

  function handleBackHome() {
    history.push("/");
  }

  const checkUserRoute = (route) => (isNaN(route) ? route : selectedUser.name);

  const routeNameFormatting = useCallback((route) => {
    const routeTabName = route.replace(/-/g, " ");
    switch (routeTabName) {
      case "acompanhar status fazenda":
      case "carregamentos fazenda":
        return routeTabName.replace("fazenda", "")
      case "acompanhar status warehouse":
      case "carregamentos warehouse":
        return routeTabName.replace("warehouse", "")
      case "carregamentos transportadoras":
        return routeTabName.replace("transportadoras", "")
      case "carregamentos motorista":
      case "acompanhar status motorista":
        return routeTabName.replace("motorista", "")
      case "users":
        return routeTabName.replace("users", "Gerenciar Usuários")
      case "listar usuarios":
        return routeTabName.replace("listar usuarios", "Listar Usuários")
      case "novo usuario":
        return routeTabName.replace("novo usuario", "Novo Usuário")
      case "aprovar usuarios":
        return routeTabName.replace("aprovar usuarios", "Aprovar Usuários")
      case "turno":
      case "planta":
      case "docas":
      case "cotaplanta":
      case "cotacliente":
        return "Configurações";
      case "agendados":
      case "fila":
      case "atendimento":
      case "atrasados":
      case "cancelados":
      case "chamado":
      case "todos":
      case "concluidos":
        return "Agendamento";
      case "unassigned":
        return "Não atribuido";
      default:
        return location.pathname.indexOf('agendamento/status') !== -1 ? 'Consultar Agendamento' : routeTabName;
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      groups.includes("shift_manager") ||
      groups.includes("plant_manager") ||
      groups.includes("dock_manager") ||
      groups.includes("plant_quota_manager") ||
      groups.includes("client_quota_manager")
    ) {
      getNotificationsFromSchedConfigAsync();
    }
  }, [getNotificationsFromSchedConfigAsync, groups]);

  useEffect(() => {
    if (pathnames.length >= 1) {
      const activeRoute = pathnames[pathnames.length - 1];
      if (activeRoute.indexOf(activeRoute) > -1) {
        setActiveRoute(routeNameFormatting(activeRoute));
      }
    }
  }, [pathnames, setActiveRoute, routeNameFormatting]);

  useEffect(() => {
    const unreadNotifications = notifications.reduce(
      (accumulator, currentValue) => {
        accumulator = !currentValue.read_date ? accumulator + 1 : accumulator;
        return accumulator;
      },
      0
    );
    setUnreadNotifications(unreadNotifications);
  }, [notifications]);

  const loadAutoImportConfig = useCallback(async () => {
    if (canToggleAutoImport()) {
      setAutoImported(await isAutoImportEnabled());
    } else {
      setAutoImported(false);
    }
  }, [isAutoImportEnabled, canToggleAutoImport]);

  const toggleAutoImport = async () => {
    await updateAutoImportEnabled(isAutoImported ? 0 : 1);
    await loadAutoImportConfig();
  };

  useEffect(() => {
    loadAutoImportConfig().catch(console.error);
  }, [loadAutoImportConfig]);

  return (
    <>
      <AppBar position="static" className={classes.content}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.header}>
            <div
              className={
                isHamburguerMenu(user.mainGroup)
                  ? classes.menuToggleDrawer
                  : classes.menuDrawerOpened
              }
            >
              <Hidden smDown>
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  data-cy="app-bar-hamburger"
                  id="app-bar-hamburger"
                  onClick={handleDrawerToggle}
                  className={
                    isHamburguerMenu(user.mainGroup)
                      ? classes.menuButton
                      : classes.notHamburguer
                  }
                >
                  <MenuIcon />
                </IconButton>
              </Hidden>
              <Hidden smUp>
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  data-cy="app-bar-menu"
                  id="app-bar-menu"
                  onClick={handleDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Hidden>
              <Hidden smDown>
                <BreadcrumbsComponent
                  pathnames={pathnames}
                  menus={menus}
                  user={user.mainGroup}
                />
              </Hidden>
            </div>
            <Hidden only={["md", "xl"]}>
              <Box className={classes.logoArea}>
                <IconButton
                  data-cy="app-bar-cargill-btn"
                  id="app-bar-cargill-btn"
                  onClick={handleBackHome}
                >
                  <img src={Logo} className={classes.logo} alt="Cargill logo" />
                </IconButton>
              </Box>
            </Hidden>
            <div className={classes.notificationsPanel}>
              <Hidden smDown>
                {canToggleAutoImport() && (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{
                        position: "absolute",
                        top: 20,
                        right: 250,
                      }}
                      size="large"
                      data-cy="app-bar-import-oc"
                      id="app-bar-import-oc"
                      onClick={() => setShowConfirmToggleImportOC(true)}
                    >
                      {isAutoImported ? "Desabilitar" : "Habilitar"} importação
                      OC
                    </Button>
                    <Confirm
                      isOpen={showConfirmToggleImportOC}
                      title="Importação OC"
                      data-cy="app-bar-modal-import-oc"
                      id="app-bar-modal-import-oc"
                      message={`Deseja realmente <strong>${
                        isAutoImported ? "Desabilitar" : "Habilitar"
                      }</strong> a auto importação de OC?`}
                      okText="Sim"
                      cancelText="Não"
                      handleClose={(confirm) => {
                        if (confirm) toggleAutoImport();
                        setShowConfirmToggleImportOC(false);
                      }}
                    />
                  </>
                )}

                <Typography
                  onClick={toggleDrawer(anchor, true)}
                  className={classes.notificationsPanelTitle}
                  id={"notification-button-drawer-id"}
                  data-cy={"notification-button-drawer-data-cy"}
                >
                  Notificações
                </Typography>
              </Hidden>
              <IconButton
                onClick={toggleDrawer(anchor, true)}
                aria-label="notification button"
                color="primary"
                className={classes.notificationButton}
                id={"notification-button-id"}
                data-cy={"notification-button-data-cy"}
              >
                <Badge
                  badgeContent={
                    unreadNotifications > 0 ? unreadNotifications : null
                  }
                  overlap="rectangular"
                  classes={{ badge: classes.badge }}
                  id={"notification-badge-drawer-id"}
                  data-cy={"notification-badge-drawer-data-cy"}
                >
                  <Hidden smDown>
                    {unreadNotifications <= 0 && (
                      <NotificationsIcon
                        id={"notifications-icon-1-id"}
                        data-cy={"notifications-icon-1-data-cy"}
                      />
                    )}
                  </Hidden>
                  <Hidden smUp>
                    <NotificationsIcon
                      id={"notifications-icon-2-id"}
                      data-cy={"notifications-icon-2-data-cy"}
                    />
                  </Hidden>
                </Badge>
              </IconButton>
            </div>
          </div>
        </Toolbar>
        <Box className={classes.inferiorArea}>
          <Typography className={classes.title} variant="h2" noWrap>
            {location.pathname === "/"
              ? `Olá, ${user.name}`
              : checkUserRoute(activeRoute)}
          </Typography>

          {canManageUser() && manageUserRoute() && (
            <>
              <Link to={newUser} className={classes.link}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.userButton}
                  size="large"
                  onClick={() => {
                    clearNewUser();
                    clearSelectedUser();
                    setManager(managerId);
                  }}
                  id="add-new-user-btn"
                  data-cy="add-new-user-btn"
                >
                  Novo Usuário
                </Button>
              </Link>
              <Link
                to={approveUser}
                className={classes.link}
                style={{ marginLeft: 10 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.userButton}
                  size="large"
                  onClick={() => {
                    clearNewUser();
                    clearSelectedUser();
                    setManager(managerId);
                  }}
                  id="approve-user-btn"
                  data-cy="approve-user-btn"
                >
                  Aprovar Usuários
                </Button>
              </Link>
            </>
          )}
        </Box>
      </AppBar>
    </>
  );
}

MainAppBar.propTypes = {
  user: PropTypes.object.isRequired,
  menus: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
const mapState = (state) => ({
  selectedUser: state.users.selectedUser,
  managerId: state.auth.user.id,
  notifications: state.notifications.allNotifications,
});
const mapDispatch = (dispatch) => ({
  clearNewUser: (payload) => dispatch.users.clearNewUserAsync(payload),
  clearSelectedUser: (payload) => dispatch.users.clearSelectedUser(payload),
  setManager: (payload) => dispatch.users.setManagerAsync(payload),
  isAutoImportEnabled: () => dispatch.configs.isAutoImportEnabled(),
  updateAutoImportEnabled: (value) =>
    dispatch.configs.updateAutoImportEnabled(value),
  getNotificationsFromSchedConfigAsync: () =>
    dispatch.notifications.getNotificationsFromSchedConfigAsync(),
});

const MainAppBarWithRouter = withRouter(MainAppBar);

export default connect(mapState, mapDispatch)(MainAppBarWithRouter);
